/* eslint-disable no-restricted-imports */

import Super from './document-request';
import classic from 'ember-classic-decorator';

@classic
export default class DocumentRequestInsuranceInfo extends Super {}
